import {ValidatorFn, AbstractControl } from '@angular/forms';

export const CustomMinLength = (minLength: any): ValidatorFn => {

  const error = {
    invalidMinLength: true,
    message: `This field must have at least ${minLength} characters`
  };

  try {
    return (control: AbstractControl): any => {

      if (!control.value) {
        return null;
      }

      if (control.value === undefined || control.value === NaN || control.value === null || control.value === '') {
        return  null;
      }

      return control.value.toString().length >= parseInt(minLength, 10) ? null : error;
    };
  } catch (error) {
  }


};



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/custom-validators/components/min-length/min-length.validator.ts